import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { LinkButton } from '../ui/Button';
import { contact, heroImage } from '../../data/site';
const indicators = ['Atención personalizada', 'Diferentes compañías', 'Orientación clara', 'Servicio en español'];
const ease = [0.23, 1, 0.32, 1] as const;
export function Hero() {
  return <section id="inicio" className="relative overflow-hidden bg-beige pt-28 lg:min-h-[92vh] lg:pt-32" data-id="element-187" data-mp="muaembu5luz9">
      {/* organic sage shapes, very low opacity */}
      <div aria-hidden="true" className="pointer-events-none absolute -right-40 -top-32 h-[520px] w-[520px] rounded-full bg-sage/25" data-id="element-188" data-mp="qtj61a1q1grn" />
      <div aria-hidden="true" className="pointer-events-none absolute -bottom-56 -left-40 h-[460px] w-[460px] rounded-full bg-sage/15" data-id="element-189" data-mp="10kdtuium8of7" />

      <div className="relative mx-auto grid max-w-shell items-center gap-14 px-5 pb-16 lg:grid-cols-[55fr_45fr] lg:gap-16 lg:px-10 lg:pb-24" data-id="element-190" data-mp="1ajmlh520dqye">
        <motion.div initial={{
        opacity: 0,
        y: 22
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        ease
      }} data-id="element-191" data-mp="9ou91wx8kvwg">
          <p className="eyebrow text-navy/70" data-id="element-192" data-mp="3vv0wqbwmxi1s">{contact.name}</p>
          <p className="eyebrow mt-2 text-teal" data-id="element-193" data-mp="3vvaq89gw27c8">
            Insurance Advisor <span className="text-gold" data-id="element-194" data-mp="3ruh51nutz6n1">•</span> {contact.npn}
          </p>

          <h1 className="mt-7 font-display text-[2.4rem] font-semibold uppercase leading-[1.08] tracking-[-0.02em] text-navy sm:text-[3.2rem] lg:text-[3.9rem]" data-id="element-195" data-mp="setwkfdfi2xr">
            Protege lo que
            <br data-id="element-196" data-mp="io9130t1xej2" />
            más importa.
            <br data-id="element-197" data-mp="in69srrtha2m" />
            <span className="text-teal" data-id="element-198" data-mp="imo7bdek9zm9">Hoy y en el futuro.</span>
          </h1>

          <p className="mt-5 font-display text-[15px] font-medium italic text-navy/60 sm:text-base" data-id="element-199" data-mp="em4ayc1tb016">
            Tu presente merece protección. Tu futuro merece una estrategia.
          </p>

          <p className="mt-6 max-w-xl text-[15px] font-light leading-relaxed text-ink/70" data-id="element-200" data-mp="16d0jx1kr4kj6">
            Te ayudo a entender tus opciones de seguros de vida, salud y protección
            suplementaria para que puedas tomar decisiones informadas para ti y las
            personas que más quieres.
          </p>

          <div className="mt-9 flex flex-col gap-3 sm:flex-row" data-id="element-201" data-mp="2qvkxctybr3wd">
            <LinkButton href="#agenda" size="lg" className="w-full sm:w-auto" data-id="element-202" data-mp="2vup83p0wd9ot">
              AGENDA UNA CITA
            </LinkButton>
            <LinkButton href="#servicios" variant="secondary" size="lg" className="w-full sm:w-auto" data-id="element-203" data-mp="2htuv0t2wmkjt">
              CONOCE MIS SERVICIOS
            </LinkButton>
          </div>

          <ul className="mt-9 grid grid-cols-1 gap-x-8 gap-y-3 sm:grid-cols-2" data-id="element-204" data-mp="27ybd5al6dme2">
            {indicators.map(i => <li key={i} className="flex items-center gap-2.5 text-[13px] text-ink/75" data-id="element-205" data-mp="2cwuyp9vuww5w">
                <CheckIcon size={15} className="shrink-0 text-forest" strokeWidth={2.2} data-id="element-206" data-mp="676l4dfbyjt7" />
                {i}
              </li>)}
          </ul>
        </motion.div>

        <motion.div className="relative" initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.55,
        delay: 0.1,
        ease
      }} data-id="element-207" data-mp="1vm8ymsdagdce">
          <div aria-hidden="true" className="absolute -left-5 -top-5 hidden h-40 w-40 rounded-full border border-gold/40 lg:block" data-id="element-208" data-mp="25dvej20kn0lh" />
          <div className="relative aspect-[3/4] overflow-hidden rounded-[110px_110px_28px_28px] bg-sand shadow-lift sm:rounded-[150px_150px_28px_28px]" data-id="element-209" data-mp="2ed8hdbu6wqx8">
            <img src={heroImage} alt="Andrea Báez Graterol, Insurance Advisor, en su oficina" className="h-full w-full object-cover object-[center_6%]" width={894} height={1789} data-id="element-210" data-mp="2abn800gv6urs" />
          </div>
          <div className="absolute -bottom-5 left-4 rounded-full border border-gold/40 bg-cream/95 px-5 py-2.5 shadow-soft backdrop-blur-sm" data-id="element-211" data-mp="tyq3naqadvqs">
            <span className="eyebrow text-gold" data-id="element-212" data-mp="p0wv4b1igpnc">{contact.npn}</span>
          </div>
        </motion.div>
      </div>
    </section>;
}